{
  "name": "forest-machines-client",
  "version": "0.92.98",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:dev": "ng serve --configuration=dev",
    "start:devtest": "ng serve --configuration=devtest",
    "start:test": "ng serve --configuration=test",
    "build:dev": "ng build --configuration=dev",
    "build:devtest": "ng build --configuration=devtest",
    "build:test": "ng build --configuration=test",
    "build:prod": "ng build --configuration=prod",
    "test": "ng test",
    "serve:ssr:ForestMachinesClient": "node dist/app/server/server.mjs"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.26",
    "@angular/cdk": "^20.2.14",
    "@angular/cli": "^20.3.32",
    "@angular/common": "^20.3.26",
    "@angular/compiler": "^20.3.26",
    "@angular/core": "^20.3.26",
    "@angular/forms": "^20.3.26",
    "@angular/material": "^20.2.14",
    "@angular/platform-browser": "^20.3.26",
    "@angular/platform-browser-dynamic": "^20.3.26",
    "@angular/platform-server": "^20.3.26",
    "@angular/router": "^20.3.26",
    "@angular/ssr": "^20.3.32",
    "@awesome.me/kit-3111ba4b6c": "^1.0.4",
    "@azure/msal-angular": "^4.0.10",
    "@azure/msal-browser": "^4.11.0",
    "@fortawesome/angular-fontawesome": "^3.0.0",
    "@fortawesome/fontawesome-pro": "^7.1.0",
    "@fortawesome/pro-light-svg-icons": "^7.1.0",
    "@fortawesome/pro-regular-svg-icons": "^7.1.0",
    "@fortawesome/pro-solid-svg-icons": "^7.1.0",
    "@microsoft/applicationinsights-web": "^3.3.10",
    "express": "^4.18.2",
    "fast-json-patch": "^3.1.1",
    "moment": "^2.30.1",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "xlsx": "^0.18.5",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^20.3.32",
    "@angular/compiler-cli": "^20.3.26",
    "@types/express": "^4.17.17",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^18.18.0",
    "jasmine-core": "~5.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "^5.9.3"
  }
}

